module.exports = __webpack_public_path__ + "static/media/mv.0cdf2e4f.svg";